import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EstimateState } from '../models/estimate-state';

@Injectable()
export class EstimateStateService {

  private estimateStateSource = new Subject<EstimateState>();
  public estimateState$ = this.estimateStateSource.asObservable();

  public estimateState(state: EstimateState) {
    this.estimateStateSource.next(state);
  }
}